
import moment from "moment"
import store from '@/store/index'
import PapelSegurancaLoteItensService from "../../services/PapelSeguranca/PapelSegurancaLoteItensService"

export class useCasePapelSegurancaLoteItem {
  constructor (papel) {
    this.papelSeguranca = papel || null
  }
  async consumir (item, registro_id = null, tipoUso = 'OS', reimprimir = null) {

    const payload  = {
      cartorio_id: store.state.auth.usuario.cartorio_id,
      usuario_id: store.state.auth.usuario.user_id,
      papel_seguranca_lote_item_id: this.papelSeguranca.papel_seguranca_lote_item_id,
      tipo_papel: item.custa.impresso_seguranca,
      numero_serie: this.papelSeguranca.numero_serie && this.papelSeguranca.numero_serie.toUpperCase(),
      data_consumo: moment().format('YYYY-MM-DD HH:mm:ss'),
      tipo_uso: tipoUso,
      registro_id: registro_id,
      ordem_servico_id: item.ordem_servico_id,
    } 
      const papelConsumido = await PapelSegurancaLoteItensService.consume(payload)
      return papelConsumido
  }

  async cancelarPapel () {
    const papelCancelado = await PapelSegurancaLoteItensService.reuseItem(this.papelSeguranca)
    return papelCancelado
  }
}